// Registro de artículos y guías (nov-2026): una sola lista para el índice
// (/articulos), las páginas de categoría y los «relacionados» del final de cada
// artículo. `updated` = última revisión del contenido (AAAA-MM-DD).
// Ya no hay páginas de categoría (4-nov-2026): el índice agrupa por categoría y
// la miga de pan enlaza a su sección (/articulos#slug).
// `image`/`imageAlt`: portada del artículo, miniatura del índice e imagen al
// compartir (GPT Image 2, marketing/prompts-imagenes/articulo-*.txt; 4-nov-2026).

export const CATEGORIES = [
  { slug: 'documentos', title: 'Documentos', text: 'Qué es cada documento de transporte y cuándo se usa.' },
  { slug: 'regulacion-y-cumplimiento', title: 'Regulación y cumplimiento', text: 'La norma que aplica a los documentos de transporte digitales.' },
];

export const ARTICLES = [
  {
    url: '/articulos/que-es-el-deca',
    image: '/images/articulos/que-es-el-deca.webp',
    imageAlt: 'Conductor junto a su camión aparcado con el DeCA abierto en el móvil',
    category: 'documentos',
    kind: 'Artículo',
    title: '¿Qué es el DeCA de transporte? El documento de control digital, explicado',
    text: 'Qué es el DeCA, a quién obliga, qué requisitos técnicos exige y cómo cumplirlo.',
    updated: '2026-11-04',
  },
  {
    url: '/articulos/diferencias-entre-dca-carta-de-porte-y-cmr-ecmr',
    image: '/images/articulos/diferencias.webp',
    imageAlt: 'Camión con semirremolque de lona en una autovía de montaña en los Pirineos',
    category: 'documentos',
    kind: 'Artículo',
    title: 'Diferencias entre DeCA, carta de porte y CMR/eCMR',
    text: 'Qué documento corresponde a cada transporte, en qué se parecen y cómo se combinan.',
    updated: '2026-11-04',
  },
  {
    url: '/articulos/formato-pdfa1a-documento-control-digital-2026',
    image: '/images/articulos/requisitos-deca.webp',
    imageAlt: 'Móvil leyendo el código QR de un documento de transporte impreso',
    category: 'regulacion-y-cumplimiento',
    kind: 'Artículo',
    title: 'Requisitos técnicos del DeCA: PDF nativo, firma avanzada y eFTI',
    text: 'Qué exige la Resolución de 5 de junio de 2026 al documento de control electrónico.',
    updated: '2026-11-04',
  },
  {
    url: '/articulos/digitalizacion-documento-control-transporte-datos-efti',
    image: '/images/articulos/digitalizacion-efti.webp',
    imageAlt: 'Oficina de tráfico al anochecer con mapas y datos de envíos en los monitores',
    category: 'regulacion-y-cumplimiento',
    kind: 'Artículo',
    title: 'Digitalización del documento de control: del PDF a los datos eFTI',
    text: 'El calendario en España: del PDF obligatorio a los datos estructurados de eFTI.',
    updated: '2026-11-04',
  },
];

export const categoryBySlug = (slug) => CATEGORIES.find((c) => c.slug === slug || c.slug.normalize('NFD').replace(/[̀-ͯ]/g, '') === slug);

export const articlesIn = (slug) => ARTICLES.filter((a) => a.category === slug);

/** Hasta `n` artículos relacionados: primero los de la misma categoría. */
export const relatedTo = (url, n = 3) => {
  const me = ARTICLES.find((a) => a.url === url);
  const same = ARTICLES.filter((a) => a.url !== url && me && a.category === me.category);
  const others = ARTICLES.filter((a) => a.url !== url && (!me || a.category !== me.category));
  return [...same, ...others].slice(0, n);
};

const MONTHS = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
export const formatDate = (ymd) => {
  if (!ymd) return '';
  const [y, m, d] = ymd.split('-').map(Number);
  return `${d} de ${MONTHS[m - 1]} de ${y}`;
};
